import * as React from "react"
import { motion } from "framer-motion"

const CircleText = props => {
  let thoughts = [
    "is this thing on?",
    "Hmmmmmmmmmmmmmmm",
    "C’est moi",
    "Hmmmmmmmmmmmmmmmmmmmmmmmmmmmmmm",
    "Bonus points if you know where Milwaukee is",
    "Click the circle and see what happens",
    "Bal du Moulin Rouge, Paris",
    "🌚",
    "🌚                  🌞",
    "🌞",
    "another coffee please",
    "mmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmm",
    "-----------------------------------------------------------------------------------------",
    "1. 2. 3. go!",
    "#hashtag",
    "What time is it?",
    "Could really use some coffee right about now",
    "https://open.spotify.com/track/1Z5B5x1vsgwmR6M4B8ndwU?si=3Nv6elSAQiCM9HDaCfWjcA",
    "https://open.spotify.com/track/3bAsARrgNU2P7WMfqeKQcC?si=g3MKa97sS5yURY6CEADIqg",
    "https://open.spotify.com/track/2TvsyqjCEeHevrpyp8YJiT?si=KtN0wfU1SvO4m_lcKE9QbQ",
    "https://open.spotify.com/track/5gatbCb4evWxs0CMMuiqGX?si=56iOl8sxScOaPl4A8vdCTw",
    "https://open.spotify.com/track/2VvH6IIsYPbzTFleVJLWRT?si=66wtWdDRTSu6IzLAJgr1qQ",
    "https://open.spotify.com/track/3XKytPDG5nXoCyCB0Bfkuz?si=Cium1DKORGuhJA4GGrW_5Q",
    "https://open.spotify.com/track/26quEhCKqIGQGgV5rAEpkt?si=dFjN_CYyQ9mcVDSRVNobOg",
    "https://open.spotify.com/track/4xSIIQaQGLDg3b3L0jie6v?si=xOmOP62rSG2DjlVX56aIjg",
    "https://open.spotify.com/track/5r5cp9IpziiIsR6b93vcnQ?si=Va9JJsd2RNy6dNPcBch3xA",
    "https://open.spotify.com/track/0lbMKWfOU7Lb6JPRXZBEKM?si=tyedN7OrSAyhM7TBex8DrQ",
    "https://open.spotify.com/track/6J4WM1iiQz39oKpFSfAHjB?si=qndWcJnhT3OzPTTrrmrypQ",
    "https://open.spotify.com/playlist/7bz5PQpQ0z5Fsz2CAmvRDq?si=j-LbnfFwTdOC6NqyNr77HA",
    "https://open.spotify.com/track/2or7WkhqXlQW3GfMJfBX5P?si=ww4iCjkCT0KXTnGOKAVrWA",
    "Hey! Listen!",
    "If you're in Amsterdam, let's meet for a coffee!",
    "Framer Motion is sweet",
    "Bon Appétit",
    "https://twitter.com/leesteffen/status/1157321107550167040",
    "https://soundcloud.com/addisonschultz",
    "(◕‿◕✿)",
    "(｡◕‿◕｡)",
    "(~˘▾˘)~",
  ]

  let randomThought = thoughts[Math.floor(Math.random() * thoughts.length)]

  return (
    <motion.div style={{ position: "relative" }}>
      <motion.div
        animate={{ rotate: 360 }}
        transition={{ loop: Infinity, duration: 10, ease: "linear" }}
      >
        <svg version="1.1" viewBox="0 0 400 400">
          <defs>
            <path
              d="M0, 200a200, 200 0 1, 0 400, 0a200, 200 0 1, 0 -400, 0"
              id="txt-path"
            />
          </defs>

          <text
            fill={props.fillColor}
            font-size="25.5"
            font-family="Helvetica Neue"
            font-weight="600"
          >
            <textPath startOffset="0" xlinkHref="#txt-path">
              {randomThought}
            </textPath>
          </text>
        </svg>
      </motion.div>
    </motion.div>
  )
}

export default CircleText
